import { render, staticRenderFns } from "./GameInKS.vue?vue&type=template&id=08acb611"
import script from "./GameInKS.vue?vue&type=script&lang=js"
export * from "./GameInKS.vue?vue&type=script&lang=js"
import style0 from "./GameInKS.vue?vue&type=style&index=0&id=08acb611&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports